export const VIKAS_KAME_CHART_CONSTANT = {
  //charts
  VIKAS_KAME_COUNT: "/dashboard/vikas-kam/counts",
};
